import React from 'react'
import { EmojiSpan } from '@components/EmojiSpan'
import { useElement } from '@udecode/plate-common/react'

import { TEmojiElement } from './autocomplete/types'

export const EmojiElement = ({ children }: { children?: React.ReactNode }) => {
    const element = useElement<TEmojiElement>()
    return (
        <EmojiSpan emoji={element.emoji} data-slate-value={element.value}>
            {children}
        </EmojiSpan>
    )
}

export const EmojiElementWithoutPlate = ({ emoji }: { emoji: string }) => {
    return <EmojiSpan emoji={emoji} />
}
